import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { GlobalService } from '../../../services/global.service';
import { MessageService } from '../../../services/message.service';
import { GraphService } from '../../../services/graphs.service';
import { Observable } from 'rxjs';
import { ConfigModel } from 'src/app/models/graphs.model';
import { WellsModel } from 'src/app/models/wells.model';
import { ViewportScroller } from '@angular/common';
import { filter } from 'rxjs/operators';
import { Router, Scroll } from '@angular/router';
import { PersonalSafetyComponent } from '../ehs/personalSafety/personalSafety.component';
import { ProcessSafetyComponent } from '../ehs/processSafety/processSafety.component';
import { UserModel } from 'src/app/models/user.model';
import * as Highcharts from 'highcharts';

const HighchartsMore = require('highcharts/highcharts-more');
const SolidGauge = require('highcharts/modules/solid-gauge');

HighchartsMore(Highcharts);
SolidGauge(Highcharts)

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
    Highcharts = Highcharts;
    //https://canvas-gauges.com/documentation/user-guide/configuration
    graphService: Observable<any>;
    wellService: Observable<any>;

    graphData: ConfigModel = new ConfigModel();
    wellData: WellsModel[];
    ehsActualHarm_highlights: string;

    ehsChart3: Object;

    opsChart1: Object;
    opsChart2: Object;
    opsChart3: Object;
    opsChart4: WellsModel[];

    finChart1: Object;
    finChart2: Object;
    finChart3: Object;
    finChart4: Object;
    gotTheData: boolean = false;
    fetchDataFailed: boolean = false;

    cooperMax: number;
    GLNGMax: number;

    element: any;

    @ViewChild('scrollMe') private myScrollContainer: ElementRef;

    @ViewChild(PersonalSafetyComponent) personalSafety: PersonalSafetyComponent;
    @ViewChild(ProcessSafetyComponent) processSafety: ProcessSafetyComponent;

    constructor(
        private globals: GlobalService,
        private graph: GraphService,
        private router: Router, private viewportScroller: ViewportScroller,
        private messageService: MessageService,
        private user: UserModel) {
        globals.hasLoaded = false;
        globals.currentPage = 0;
        this.graphData = new ConfigModel();

        const returnUrl = localStorage.getItem('returnUrl') ? decodeURI(localStorage.getItem('returnUrl')) : '';
        console.log('Return URL');
        console.log(returnUrl);
        if (returnUrl == undefined || returnUrl == '' || returnUrl.indexOf('graphs') < 0) {
            console.log('Normal Load');
            this.graphs();
            this.router.events.pipe(filter(e => e instanceof Scroll)).subscribe((e: any) => {
                this.element = e;
            });
        }
        else {
            console.log('Clear storage & refresh to ' + returnUrl);
            localStorage.removeItem('returnUrl');
            this.router.navigateByUrl(returnUrl);
        }
    }

    graphs() {
        this.graphService = this.graph.getConfig();
        this.wellService = this.graph.getWells();


        this.graphService.subscribe(data => {
            console.log('Fetched Graphs:');
            this.graphData = data.contents;
            console.log(this.graphData);
            this.ehs1();
            this.ehs3();

            this.ops1();
            this.ops2();
            this.ops3();

            this.fin1();
            this.fin2();
            this.fin3();
            this.fin4();

            setTimeout(() => {
                this.personalSafety.refresh();
                this.processSafety.refresh();

                // this is fix for dynamic generated(loaded..?) content
                setTimeout(() => {
                    if (this.element.position) {
                        this.viewportScroller.scrollToPosition(this.element.position);
                    } else if (this.element.anchor) {
                        this.viewportScroller.scrollToAnchor(this.element.anchor);
                    } else {
                        this.viewportScroller.scrollToPosition([0, 0]);
                    }
                }, 100);
            });
            this.globals.hasLoaded = true;
            this.gotTheData = true;
        }, err => {
            console.log(err);
            this.globals.hasLoaded = true;
            let msg = "Error fetching graph details";
            if (err.message != undefined)
                msg += ': ' + err.message;
            this.fetchDataFailed = true;
            this.messageService.sendErrorMessage(msg);
        });

        this.wellService.subscribe(data => {
            console.log('Fetched Wells:');
            this.wellData = data.contents;
            console.log(this.wellData);
            this.ops4();
        }, err => {
            console.log(err);
            this.globals.hasLoaded = true;
            let msg = "Error fetching graph details";
            if (err.message != undefined)
                msg += ': ' + err.message;
            this.fetchDataFailed = true;
            this.messageService.sendErrorMessage(msg);
        });
    }

    /********************************************************
            EHS
    *********************************************************/
    ehs1() {

        this.ehsActualHarm_highlights = '[{"from": 0, "to": ' + this.graphData.ehs_Injury_Yellow + ', "color": "rgba(255, 255, 77, .75)"},';
        this.ehsActualHarm_highlights += '{"from": ' + this.graphData.ehs_Injury_Yellow + ', "to": ' + this.graphData.ehs_Injury_Orange + ', "color": "rgba(255, 153, 0, .75)"},';
        this.ehsActualHarm_highlights += '{"from": ' + this.graphData.ehs_Injury_Orange + ', "to": ' + this.graphData.ehs_Injury_Max + ', "color": "rgba(255, 51, 51, .75)"} ]'
    }

    ehs3() {
        this.ehsChart3 = {
            credits: {
                enabled: false
            },

            chart: {
                type: 'solidgauge',
                height: '220',
                backgroundColor: "#fff",
                borderWidth: 0,
                borderRadius: 0,
                borderColor: "#90a4ae",
                plotBackgroundColor: "#fff",
            },
            exporting: { enabled: false },
            title: {
                text: null
            },
            pane: {
                center: ["50%", "50%"],
                size: '150%',
                startAngle: -90,
                endAngle: 90,
                background: {
                    backgroundColor: '#EEE',
                    innerRadius: '60%',
                    outerRadius: '100%',
                    shape: 'arc'
                },
            },

            tooltip: {
                enabled: false
            },

            yAxis: {
                min: 0,
                max: this.graphData.ehs_Process_Max,
                stops: [
                    [0, '#ffff4d'],
                    [this.graphData.ehs_Process_Yellow / this.graphData.ehs_Process_Max, '#FFA500'],
                    [this.graphData.ehs_Process_Orange / this.graphData.ehs_Process_Max, '#DF5353'] // red
                ],
                tickInterval: this.graphData.ehs_Process_Max,
                minorTickInterval: 200,
                majorTickInterval: 200,
                labels: {
                    y: 16
                },
                tickColor: '#DFDFDF',
            },

            series: [{
                data: [this.graphData.ehs_Process_CurrentYearValue],
                dataLabels: {
                    enabled: false
                }
            }]
        };
    }

    /********************************************************
            Operational
    *********************************************************/
    ops1() {
        this.opsChart1 = {
            credits: {
                enabled: false
            },
            exporting: { enabled: false },
            chart: {
                type: "column",
                width: null,
                style: {
                    fontFamily: "Verdana",
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                },
                backgroundColor: "#fff",
                plotBorderWidth: 0,
                plotBackgroundColor: "#ffffff",
            },
            tooltip: {
                enabled: false
            },

            title: {
                text: 'Production Volumes',
                style: {
                    fontFamily: "Verdana",
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            subtitle: {
                text: 'Avg. daily production for ' + this.getDateForDisplay(this.graphData.ops_CurrentMonth, this.graphData.ops_CurrentYear),
                style: {
                    fontFamily: "Verdana",
                    color: "#666666",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            xAxis: {
                type: "category",
                allowDecimals: false,
                tickInterval: 1,
                labels: {
                    enabled: true,
                },
                tickPosition: 'inside',
                crosshair: true,
                index: 0,
                isX: true,
                title: {
                    style: {
                        fontFamily: "Verdana",
                        color: "#666666",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                gridLineWidth: 0,
                stackLabels: {
                    enabled: false,
                    style: {
                        fontWeight: 'bold',
                        color: 'gray'
                    }
                }
            },
            yAxis: [{
                title: {
                    text: 'kboe/day',
                    style: {
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                min: 0,
                max: this.graphData.ops_ProdArea_Max,
                tickInterval: 10,
                minorTickInterval: 0,
                majorTickInterval: 0,
                labels: {
                    formatter: function () {
                        return ' '
                    }
                },
                gridLineWidth: 0,
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'gray'
                    }
                }
            }
            ],
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: false,
                        format: '{point.y}'
                    },
                    stacking: 'normal'
                }
            },
            series: [{
                data: [{ name: 'Onshore EA', y: this.graphData.ops_ProdArea_OnshoreEA }],
                showInLegend: false,
            }, {
                data: [{ name: 'Offshore WA', y: this.graphData.ops_ProdArea_OffshoreWA }],
                showInLegend: false,
            }, {
                data: [{ name: 'Offshore NA', y: this.graphData.ops_ProdArea_OffshoreNA }],
                showInLegend: false,
            }, {
                data: [{ name: 'PNG', y: this.graphData.ops_ProdArea_PNG }],
                showInLegend: false,
            }],
            colors: ["#85b1d3", "#b6c8d6", "#85b1d3", "#58a1d8"]
        };
    }

    ops2() {
        this.opsChart2 = {
            credits: {
                enabled: false
            },
            exporting: { enabled: false },
            chart: {
                type: "column",
                width: null,
                style: {
                    fontFamily: "Verdana",
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                },
                backgroundColor: "#fff",
                plotBorderWidth: 0,
                plotBackgroundColor: "#ffffff",
            },
            tooltip: {
                enabled: false
            },

            title: {
                text: 'Production Volumes',
                style: {
                    fontFamily: "Verdana",
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            subtitle: {
                text: 'Avg. daily production for ' + this.getDateForDisplay(this.graphData.ops_CurrentMonth, this.graphData.ops_CurrentYear),
                style: {
                    fontFamily: "Verdana",
                    color: "#666666",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            xAxis: {
                type: "category",
                allowDecimals: false,
                tickInterval: 1,
                labels: {
                    enabled: true,
                },
                tickPosition: 'inside',
                crosshair: true,
                index: 0,
                isX: true,
                title: {
                    style: {
                        fontFamily: "Verdana",
                        color: "#666666",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                gridLineWidth: 0,
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'gray'
                    }
                }
            },
            yAxis: [{
                title: {
                    text: 'kboe/day',
                    style: {
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                min: 0,
                max: this.graphData.ops_ProdType_Max,
                tickInterval: 10,
                minorTickInterval: 0,
                majorTickInterval: 0,
                labels: {
                    formatter: function () {
                        return ' '
                    }
                },
                gridLineWidth: 0,
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'gray'
                    }
                }
            }
            ],
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: false,
                        format: '{point.y}'
                    },
                    stacking: 'normal'
                }
            },

            series: [{
                data: [{ name: 'Gas', y: this.graphData.ops_ProdType_Domgas }],
                showInLegend: false,
            }, {
                data: [{ name: 'Liquids', y: this.graphData.ops_ProdType_Liquids }],
                showInLegend: false,
            }, {
                data: [{ name: 'LNG', y: this.graphData.ops_ProdType_LNG }],
                showInLegend: false,
            }],
            colors: ["#85b1d3", "#b6c8d6", "#85b1d3"]
        };
    }

    ops3() {

        this.graphService = this.graph.getConfig();
        this.graphService.subscribe(data => {

            this.graphData = data.contents;

            let arrCooper: any[] = [];

            arrCooper[0] = this.graphData.ops_Drilled_Cooper_Dec;
            arrCooper[1] = this.graphData.ops_Drilled_Cooper_Nov;
            arrCooper[2] = this.graphData.ops_Drilled_Cooper_Oct;
            arrCooper[3] = this.graphData.ops_Drilled_Cooper_Sep;
            arrCooper[4] = this.graphData.ops_Drilled_Cooper_Aug;
            arrCooper[5] = this.graphData.ops_Drilled_Cooper_Jul;
            arrCooper[6] = this.graphData.ops_Drilled_Cooper_Jun;
            arrCooper[7] = this.graphData.ops_Drilled_Cooper_May;
            arrCooper[8] = this.graphData.ops_Drilled_Cooper_Apr;
            arrCooper[9] = this.graphData.ops_Drilled_Cooper_Mar;
            arrCooper[10] = this.graphData.ops_Drilled_Cooper_Feb;
            arrCooper[11] = this.graphData.ops_Drilled_Cooper_Jan;
            let maxCooper = arrCooper[0];
            for (var i = 0; i < arrCooper.length; i++) {
                if (arrCooper[i] > maxCooper)
                    maxCooper = arrCooper[i];
            }
            this.cooperMax = maxCooper;

            let arrGLNG: any[] = [];

            arrGLNG[0] = this.graphData.ops_Drilled_GLNG_Dec;
            arrGLNG[1] = this.graphData.ops_Drilled_GLNG_Nov;
            arrGLNG[2] = this.graphData.ops_Drilled_GLNG_Oct;
            arrGLNG[3] = this.graphData.ops_Drilled_GLNG_Sep;
            arrGLNG[4] = this.graphData.ops_Drilled_GLNG_Aug;
            arrGLNG[5] = this.graphData.ops_Drilled_GLNG_Jul;
            arrGLNG[6] = this.graphData.ops_Drilled_GLNG_Jun;
            arrGLNG[7] = this.graphData.ops_Drilled_GLNG_May;
            arrGLNG[8] = this.graphData.ops_Drilled_GLNG_Apr;
            arrGLNG[9] = this.graphData.ops_Drilled_GLNG_Mar;
            arrGLNG[10] = this.graphData.ops_Drilled_GLNG_Feb;
            arrGLNG[11] = this.graphData.ops_Drilled_GLNG_Jan;
            let maxGLNG = arrGLNG[0];

            for (var i = 0; i < arrGLNG.length; i++) {
                if (arrGLNG[i] > maxGLNG)
                    maxGLNG = arrGLNG[i];
            }
            this.GLNGMax = maxGLNG;

            this.checkNullOrBlankValues();

            this.opsChart3 = {
                credits: {
                    enabled: false
                },
                exporting: { enabled: false },
                chart: {
                    type: "spline",
                    width: null,
                    style: {
                        fontFamily: "Verdana",
                        color: "#333",
                        fontSize: "12px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    },
                    backgroundColor: "#fff",
                    plotBorderWidth: 0,
                    plotBackgroundColor: "#ffffff",
                },
                title: {
                    text: 'Wells drilled & connected',
                    style: {
                        fontFamily: "Verdana",
                        color: "#333333",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                subtitle: {
                    text: this.graphData.ops_Drilled_SubHeading, //'Cooper: 7 connected YTD<br>GLNG: 5 connected YTD',
                    style: {
                        fontFamily: "Verdana",
                        color: "#666666",
                        fontSize: "14px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                xAxis: {
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Target'],
                    allowDecimals: false,
                    tickInterval: 1,
                    labels: {
                        enabled: true,
                    },
                    tickPosition: 'inside',
                    crosshair: true,
                    index: 0,
                    isX: true,
                    title: {
                        style: {
                            fontFamily: "Verdana",
                            color: "#666666",
                            fontSize: "18px",
                            fontWeight: "normal",
                            fontStyle: "normal"
                        }
                    },
                },
                yAxis: [{
                    title: {
                        text: 'Wells Drilled',
                        style: {
                            fontFamily: "Verdana",
                            fontSize: "18px",
                            fontWeight: "normal",
                            fontStyle: "normal"
                        }
                    },
                    min: 0,
                    max: this.graphData.ops_Drilled_Max,
                    tickInterval: 50,
                    minorTickInterval: 50,
                    majorTickInterval: 50,
                    labels: {
                        formatter: function () {
                            return this.value;
                        }
                    },
                }],
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        },
                        enableMouseTracking: false
                    },
                    spline: {
                        marker: {
                            radius: 4,
                            lineColor: '#666666',
                            lineWidth: 1,

                        }
                    }
                },
                tooltip: {
                    formatter: function () {
                        var area = 'Cooper';
                        if (this.series.name.indexOf('GLNG') > -1)
                            area = 'GLNG';
                        var d = new Date();
                        var n = d.getFullYear();
                        if (this.x == 'Target') {
                            return '<b>' + area + '</b> target for ' + n + ': <b>' + this.y + '</b>';
                        }
                        if (this.series.name.indexOf('' + n) == -1) {
                            // Single line
                            return '<b>' + area + '</b> wells drilled ' + '' + (n - 1) + ': <b>' + this.y + '</b>';
                        }
                        return '<b>' + area + '</b> wells drilled ' + this.x + ' ' + n + ': <b>' + this.y + '</b>';
                    }
                },
                series: [
                    {
                        name: this.graphData.ops_CurrentYear - 1 + ' Cooper - ' + this.graphData.ops_Drilled_Cooper_LastYear + ' Wells',
                        dashStyle: 'shortdot',
                        marker: {
                            enabled: false
                        },
                        data: [this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear,
                        this.graphData.ops_Drilled_Cooper_LastYear]
                    },
                    {
                        name: this.graphData.ops_CurrentYear + ' Cooper - ' + this.cooperMax + ' Wells',
                        marker: {
                            symbol: 'diamond'
                        },
                        data:
                            [
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Jan,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Jan == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Feb,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Feb == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Mar,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Mar == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Apr,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Apr == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_May,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_May == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Jun,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Jun == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Jul,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Jul == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Aug,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Aug == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Sep,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Sep == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Oct,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Oct == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Nov,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Nov == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Dec,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_Cooper_Dec == this.cooperMax),
                                        symbol: 'diamond'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_Cooper_Target,
                                    marker: { symbol: 'url(assets/images/target1.png)' }
                                }
                            ]
                    },
                    {
                        name: this.graphData.ops_CurrentYear - 1 + ' GLNG - ' + this.graphData.ops_Drilled_GLNG_LastYear + ' Wells',
                        dashStyle: 'shortdot',
                        marker: {
                            enabled: false
                        },
                        data: [this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear,
                        this.graphData.ops_Drilled_GLNG_LastYear]
                    },
                    {
                        name: this.graphData.ops_CurrentYear + ' GLNG - ' + this.GLNGMax + ' Wells',
                        marker: {
                            symbol: 'square'
                        },
                        data:
                            [
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Jan,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Jan == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Feb,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Feb == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Mar,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Mar == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Apr,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Apr == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_May,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_May == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Jun,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Jun == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Jul,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Jul == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Aug,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Aug == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Sep,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Sep == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Oct,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Oct == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Nov,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Nov == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Dec,
                                    marker: {
                                        enabled: (this.graphData.ops_Drilled_GLNG_Dec == this.GLNGMax),
                                        symbol: 'square'
                                    },
                                },
                                {
                                    y: this.graphData.ops_Drilled_GLNG_Target,
                                    marker: { symbol: 'url(assets/images/target2.png)' }
                                }
                            ]
                    },
                ],
                colors: ["#0088CE", "#0088CE", "#00A739", "#00A739"]
            };
        });
    }

    ops4() {
        this.opsChart4 = [];
        for (var i = 0; i < this.wellData.length; i++) {
            let newentry = new WellsModel();
            newentry.wellName = this.wellData[i].wellName;
            newentry.target = this.wellData[i].target,
                newentry.wellType = this.wellData[i].wellType,
                newentry.basin = this.wellData[i].basin,
                newentry.status = this.wellData[i].status
            this.opsChart4.push(newentry);
        }
        // this.opsChart4 = [
        //     {
        //         "WellName": "Well 1",
        //         "WellType": "Wild Cat",
        //         "Basin": "Armadeus",
        //         // "Santos": "100%",
        //         "WellStatus": "Drilling"
        //     },
        //     {
        //         "WellName": "Well 2",
        //         "WellType": "Appraisal",
        //         "Basin": "McArthur",
        //         // "Santos": "70%",
        //         "WellStatus": "C&S Successful"
        //     }
        // ];
    }

    /********************************************************
            Financial
    *********************************************************/
    fin1() {
        this.finChart1 = {
            credits: {
                enabled: false
            },
            exporting: { enabled: false },
            chart: {
                type: "column",
                width: null,
                style: {
                    fontFamily: "Verdana",
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                },
                backgroundColor: "#fff",
                borderWidth: 1,
                borderRadius: 0,
                borderColor: "#90a4ae",
                plotBorderWidth: 0,
                plotBackgroundColor: "#ffffff",
            },
            tooltip: {
                enabled: false
            },

            title: {
                text: 'Sales Revenue',
                style: {
                    fontFamily: "Verdana",
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            subtitle: {
                text: '',
                style: {
                    fontFamily: "Verdana",
                    color: "#666666",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            xAxis: {
                allowDecimals: false,
                tickInterval: 1,
                type: "category",
                labels: {
                    enabled: true,
                },
                tickPosition: 'inside',
                crosshair: true,
                index: 0,
                isX: true,
                title: {
                    style: {
                        fontFamily: "Verdana",
                        color: "#666666",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
            },
            yAxis: [{
                title: {
                    text: '$ million',
                    style: {
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                min: 0,
                max: this.graphData.fin_Revenue_Max,
                tickInterval: this.graphData.fin_Revenue_Max,
                minorTickInterval: this.graphData.fin_Revenue_Max,
                majorTickInterval: this.graphData.fin_Revenue_Max,
                labels: {
                    formatter: function () {
                        return ' '
                    }
                },
                gridLineWidth: 0,
            }],
            plotOptions: {
                series: {
                    grouping: false,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                        color: "gray"
                    }
                }
            },
            series: [
                {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Revenue_Name1, y: this.graphData.fin_Revenue_1 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Revenue_Name2, y: this.graphData.fin_Revenue_2 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Revenue_Name3, y: this.graphData.fin_Revenue_3 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Revenue_Name4, y: this.graphData.fin_Revenue_4 }],
                }],
            colors: ["#d4d3d3", "#b6c8d6", "#85b1d3", "#58a1d8"]
        };
    }

    fin2() {
        this.finChart2 = {
            credits: {
                enabled: false
            },
            exporting: { enabled: false },
            chart: {
                type: "column",
                width: null,
                style: {
                    fontFamily: "Verdana",
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                },
                backgroundColor: "#fff",
                borderWidth: 1,
                borderRadius: 0,
                borderColor: "#90a4ae",
                plotBorderWidth: 0,
                plotBackgroundColor: "#ffffff",
            },
            tooltip: {
                enabled: false
            },

            title: {
                text: 'Upstream Unit Production Cost',
                style: {
                    fontFamily: "Verdana",
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            subtitle: {
                text: '',
                style: {
                    fontFamily: "Verdana",
                    color: "#666666",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            xAxis: {
                allowDecimals: false,
                tickInterval: 1,
                type: "category",
                labels: {
                    enabled: true,
                },
                tickPosition: 'inside',
                crosshair: true,
                index: 0,
                isX: true,
                title: {
                    style: {
                        fontFamily: "Verdana",
                        color: "#666666",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
            },
            yAxis: [{
                title: {
                    text: '$/boe',
                    style: {
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                min: 0,
                max: this.graphData.fin_Cost_Max,
                tickInterval: this.graphData.fin_Cost_Max,
                minorTickInterval: this.graphData.fin_Cost_Max,
                majorTickInterval: this.graphData.fin_Cost_Max,
                labels: {
                    formatter: function () {
                        return ' '
                    }
                },
                gridLineWidth: 0,
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'gray'
                    }
                }
            }
            ],
            plotOptions: {
                series: {
                    grouping: false,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                        color: "gray"
                    }
                }
            },

            series: [
                {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Cost_Name1, y: this.graphData.fin_Cost_1 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Cost_Name2, y: this.graphData.fin_Cost_2 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Cost_Name3, y: this.graphData.fin_Cost_3 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Cost_Name4, y: this.graphData.fin_Cost_4 }],
                }],
            colors: ["#d4d3d3", "#b6c8d6", "#85b1d3", "#58a1d8"]
        };
    }

    fin3() {
        this.finChart3 = {
            credits: {
                enabled: false
            },
            exporting: { enabled: false },
            chart: {
                type: "column",
                width: null,
                style: {
                    fontFamily: "Verdana",
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                },
                backgroundColor: "#fff",
                borderWidth: 1,
                borderRadius: 0,
                borderColor: "#90a4ae",
                plotBorderWidth: 0,
                plotBackgroundColor: "#ffffff",
            },
            tooltip: {
                enabled: false
            },

            title: {
                text: 'Free Cash Flow',
                style: {
                    fontFamily: "Verdana",
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            subtitle: {
                text: '',
                style: {
                    fontFamily: "Verdana",
                    color: "#666666",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            xAxis: {
                allowDecimals: false,
                tickInterval: 1,
                type: "category",
                labels: {
                    enabled: true,
                },
                tickPosition: 'inside',
                crosshair: true,
                index: 0,
                isX: true,
                title: {
                    style: {
                        fontFamily: "Verdana",
                        color: "#666666",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
            },
            yAxis: [{
                title: {
                    text: '$ million',
                    style: {
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                min: 0,
                max: this.graphData.fin_Cash_Max,
                tickInterval: this.graphData.fin_Cash_Max,
                minorTickInterval: this.graphData.fin_Cash_Max,
                majorTickInterval: this.graphData.fin_Cash_Max,
                labels: {
                    formatter: function () {
                        return ' '
                    }
                },
                gridLineWidth: 0,
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'gray'
                    }
                }
            }
            ],
            plotOptions: {
                series: {
                    grouping: false,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                        color: "gray"
                    }
                }
            },
            series: [
                {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Cash_Name1, y: this.graphData.fin_Cash_1 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Cash_Name2, y: this.graphData.fin_Cash_2 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Cash_Name3, y: this.graphData.fin_Cash_3 }],
                }, {
                    showInLegend: false,
                    data: [{ name: this.graphData.fin_Cash_Name4, y: this.graphData.fin_Cash_4 }],
                }],

            colors: ["#d4d3d3", "#b6c8d6", "#85b1d3", "#58a1d8"]
        };
    }

    fin4() {
        this.finChart4 = {
            credits: {
                enabled: false
            },
            exporting: { enabled: false },
            chart: {
                type: "line",
                width: null,
                style: {
                    fontFamily: "Verdana",
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                },
                backgroundColor: "#fff",
                borderWidth: 1,
                borderRadius: 0,
                borderColor: "#90a4ae",
                plotBorderWidth: 0,
                plotBackgroundColor: "#ffffff",
            },
            title: {
                text: 'Gearing',
                style: {
                    fontFamily: "Verdana",
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            xAxis: {
                categories: [this.graphData.fin_Gearing_Name1,
                this.graphData.fin_Gearing_Name2, this.graphData.fin_Gearing_Name3, this.graphData.fin_Gearing_Name4],
            },
            yAxis: [{
                title: {
                    text: '%',
                    // style: {
                    //     fontFamily: "Verdana",
                    //     fontSize: "18px",
                    //     fontWeight: "normal",
                    //     fontStyle: "normal"
                    // }
                },
                // min: 15, 
                // max: this.graphData.fin_Gearing_Max, 
                tickInterval: 5,
                minorTickInterval: 5,
                majorTickInterval: 5,
                gridLineWidth: 0,
                labels: {
                    formatter: function () {
                        return this.value;
                    }
                }
            }],

            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                enabled: false
            },

            // plotOptions: {
            //     line: {
            //         dataLabels: {
            //             enabled: false
            //         },
            //         enableMouseTracking: false
            //     },
            //     spline: {
            //         marker: {
            //             radius: 4,
            //             lineColor: '#666666',
            //             lineWidth: 1,

            //         }
            //     }
            // },
            tooltip: {
                outside: true
            },

            // series: [{
            //     name: '',
            //     showInLegend: false,  
            //     data: [20, 20, 20, 20]
            // }],

            series: [{
                showInLegend: false,
                name: 'Gearing',
                data: [this.graphData.fin_Gearing_1, this.graphData.fin_Gearing_2, this.graphData.fin_Gearing_3, this.graphData.fin_Gearing_4],
            }],

            colors: ["#58a1d8"],
        };
    }

    /********************************************************
            Utils
    *********************************************************/
    getDateForDisplay(month: number, year: number): string {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var retVal: string = months[month - 1];
        retVal += ' ' + year;
        return retVal;
    }

    checkNullOrBlankValues() {

        var x1 = this.graphData.ops_Drilled_Cooper_Target;
        if ((x1) && (x1 != 0)) {
            var y1: number = +x1;
            this.graphData.ops_Drilled_Cooper_Target = y1;
        } else if (x1 == 0) {
            this.graphData.ops_Drilled_Cooper_Target = null;
        }

        var x2 = this.graphData.ops_Drilled_Cooper_LastYear;
        if ((x2) && (x2 != 0)) {
            var y2: number = +x2;
            this.graphData.ops_Drilled_Cooper_LastYear = y2;
        } else if (x2 == 0) {
            this.graphData.ops_Drilled_Cooper_LastYear = null;
        }

        var x3 = this.graphData.ops_Drilled_Cooper_Jan;
        if ((x3) && (x3 != 0)) {
            var y3: number = +x3;
            this.graphData.ops_Drilled_Cooper_Jan = y3;
        } else if (x3 == 0) {
            this.graphData.ops_Drilled_Cooper_Jan = null;
        }

        var x4 = this.graphData.ops_Drilled_Cooper_Feb;
        if ((x4) && (x4 != 0)) {
            var y4: number = +x4;
            this.graphData.ops_Drilled_Cooper_Feb = y4;
        } else if (x4 == 0) {
            this.graphData.ops_Drilled_Cooper_Feb = null;
        }

        var x5 = this.graphData.ops_Drilled_Cooper_Mar;
        if ((x5) && (x5 != 0)) {
            var y5: number = +x5;
            this.graphData.ops_Drilled_Cooper_Mar = y5;
        } else if (x5 == 0) {
            this.graphData.ops_Drilled_Cooper_Mar = null;
        }

        var x6 = this.graphData.ops_Drilled_Cooper_Apr;
        if ((x6) && (x6 != 0)) {
            var y6: number = +x6;
            this.graphData.ops_Drilled_Cooper_Apr = y6;
        } else if (x6 == 0) {
            this.graphData.ops_Drilled_Cooper_Apr = null;
        }

        var x7 = this.graphData.ops_Drilled_Cooper_May;
        if ((x7) && (x7 != 0)) {
            var y7: number = +x7;
            this.graphData.ops_Drilled_Cooper_May = y7;
        } else if (x7 == 0) {
            this.graphData.ops_Drilled_Cooper_May = null;
        }

        var x8 = this.graphData.ops_Drilled_Cooper_Jun;
        if ((x8) && (x8 != 0)) {
            var y8: number = +x8;
            this.graphData.ops_Drilled_Cooper_Jun = y8;
        } else if (x8 == 0) {
            this.graphData.ops_Drilled_Cooper_Jun = null;
        }

        var x9 = this.graphData.ops_Drilled_Cooper_Jul;
        if ((x9) && (x9 != 0)) {
            var y9: number = +x9;
            this.graphData.ops_Drilled_Cooper_Jul = y9;
        } else if (x9 == 0) {
            this.graphData.ops_Drilled_Cooper_Jul = null;
        }

        var x10 = this.graphData.ops_Drilled_Cooper_Aug;
        if ((x10) && (x10 != 0)) {
            var y10: number = +x10;
            this.graphData.ops_Drilled_Cooper_Aug = y10;
        } else if (x10 == 0) {
            this.graphData.ops_Drilled_Cooper_Aug = null;
        }

        var x11 = this.graphData.ops_Drilled_Cooper_Sep;
        if ((x11) && (x11 != 0)) {
            var y11: number = +x11;
            this.graphData.ops_Drilled_Cooper_Sep = y11;
        } else if (x11 == 0) {
            this.graphData.ops_Drilled_Cooper_Sep = null;
        }

        var x12 = this.graphData.ops_Drilled_Cooper_Oct;
        if ((x12) && (x12 != 0)) {
            var y12: number = +x12;
            this.graphData.ops_Drilled_Cooper_Oct = y12;
        } else if (x12 == 0) {
            this.graphData.ops_Drilled_Cooper_Oct = null;
        }

        var x13 = this.graphData.ops_Drilled_Cooper_Nov;
        if ((x13) && (x13 != 0)) {
            var y13: number = +x13;
            this.graphData.ops_Drilled_Cooper_Nov = y13;
        } else if (x13 == 0) {
            this.graphData.ops_Drilled_Cooper_Nov = null;
        }

        var x14 = this.graphData.ops_Drilled_Cooper_Dec;
        if ((x14) && (x14 != 0)) {
            var y14: number = +x14;
            this.graphData.ops_Drilled_Cooper_Dec = y14;
        } else if (x14 == 0) {
            this.graphData.ops_Drilled_Cooper_Dec = null;
        }

        var x15 = this.graphData.ops_Drilled_GLNG_Target;
        if ((x15) && (x15 != 0)) {
            var y15: number = +x15;
            this.graphData.ops_Drilled_GLNG_Target = y15;
        } else if (x15 == 0) {
            this.graphData.ops_Drilled_GLNG_Target = null;
        }

        var x16 = this.graphData.ops_Drilled_GLNG_LastYear;
        if ((x16) && (x16 != 0)) {
            var y16: number = +x16;
            this.graphData.ops_Drilled_GLNG_LastYear = y16;
        } else if (x16 == 0) {
            this.graphData.ops_Drilled_GLNG_LastYear = null;
        }

        var x17 = this.graphData.ops_Drilled_GLNG_Jan;
        if ((x17) && (x17 != 0)) {
            var y17: number = +x17;
            this.graphData.ops_Drilled_GLNG_Jan = y17;
        } else if (x17 == 0) {
            this.graphData.ops_Drilled_GLNG_Jan = null;
        }

        var x18 = this.graphData.ops_Drilled_GLNG_Feb;
        if ((x18) && (x18 != 0)) {
            var y18: number = +x18;
            this.graphData.ops_Drilled_GLNG_Feb = y18;
        } else if (x18 == 0) {
            this.graphData.ops_Drilled_GLNG_Feb = null;
        }

        var x19 = this.graphData.ops_Drilled_GLNG_Mar;
        if ((x19) && (x19 != 0)) {
            var y19: number = +x19;
            this.graphData.ops_Drilled_GLNG_Mar = y19;
        } else if (x19 == 0) {
            this.graphData.ops_Drilled_GLNG_Mar = null;
        }

        var x20 = this.graphData.ops_Drilled_GLNG_Apr;
        if ((x20) && (x20 != 0)) {
            var y20: number = +x20;
            this.graphData.ops_Drilled_GLNG_Apr = y20;
        } else if (x20 == 0) {
            this.graphData.ops_Drilled_GLNG_Apr = null;
        }

        var x21 = this.graphData.ops_Drilled_GLNG_May;
        if ((x21) && (x21 != 0)) {
            var y21: number = +x21;
            this.graphData.ops_Drilled_GLNG_May = y21;
        } else if (x21 == 0) {
            this.graphData.ops_Drilled_GLNG_May = null;
        }

        var x22 = this.graphData.ops_Drilled_GLNG_Jun;
        if ((x22) && (x22 != 0)) {
            var y22: number = +x22;
            this.graphData.ops_Drilled_GLNG_Jun = y22;
        } else if (x22 == 0) {
            this.graphData.ops_Drilled_GLNG_Jun = null;
        }

        var x23 = this.graphData.ops_Drilled_GLNG_Jul;
        if ((x23) && (x23 != 0)) {
            var y23: number = +x23;
            this.graphData.ops_Drilled_GLNG_Jul = y23;
        } else if (x23 == 0) {
            this.graphData.ops_Drilled_GLNG_Jul = null;
        }

        var x24 = this.graphData.ops_Drilled_GLNG_Aug;
        if ((x24) && (x24 != 0)) {
            var y24: number = +x24;
            this.graphData.ops_Drilled_GLNG_Aug = y24;
        } else if (x24 == 0) {
            this.graphData.ops_Drilled_GLNG_Aug = null;
        }

        var x25 = this.graphData.ops_Drilled_GLNG_Sep;
        if ((x25) && (x25 != 0)) {
            var y25: number = +x25;
            this.graphData.ops_Drilled_GLNG_Sep = y25;
        } else if (x25 == 0) {
            this.graphData.ops_Drilled_GLNG_Sep = null;
        }

        var x26 = this.graphData.ops_Drilled_GLNG_Oct;
        if ((x26) && (x26 != 0)) {
            var y26: number = +x26;
            this.graphData.ops_Drilled_GLNG_Oct = y26;
        } else if (x26 == 0) {
            this.graphData.ops_Drilled_GLNG_Oct = null;
        }

        var x27 = this.graphData.ops_Drilled_GLNG_Nov;
        if ((x27) && (x27 != 0)) {
            var y27: number = +x27;
            this.graphData.ops_Drilled_GLNG_Nov = y27;
        } else if (x27 == 0) {
            this.graphData.ops_Drilled_GLNG_Nov = null;
        }

        var x28 = this.graphData.ops_Drilled_GLNG_Dec;
        if ((x28) && (x28 != 0)) {
            var y28: number = +x28;
            this.graphData.ops_Drilled_GLNG_Dec = y28;
        } else if (x28 == 0) {
            this.graphData.ops_Drilled_GLNG_Dec = null;
        }

        var x29 = this.graphData.ops_Drilled_Max;
        if ((x29) && (x29 != 0)) {
            var y29: number = +x29;
            this.graphData.ops_Drilled_Max = y29;
        } else if (x29 == 0) {
            this.graphData.ops_Drilled_Max = null;
        }
    }
}